import PageContainer from './PageContainer.component';

export * from './PageContainer.styled';

export default PageContainer;
